import { useMemo } from "react";
import { useLang } from "../context/LangContext";
import "../styles/pages/OurTeam.css";

export default function OurTeam() {
  const { dict } = useLang();

  const content = useMemo(() => {
    const source = dict?.ourTeam ?? {};

    return {
      eyebrow: source.eyebrow ?? "",
      title: source.title ?? "",
      text: source.text ?? "",
      preparingTitle: source.preparingTitle ?? "",
      noteText: source.note ?? "",
      members: Array.isArray(source.members) ? source.members : [],
    };
  }, [dict]);

  const outsideTitle = content.preparingTitle || content.title;

  return (
    <section className="OurTeam-section page-section" id="our-team">
      {outsideTitle ? (
        <div className="OurTeam-titleOutsideWrap">
          <h2 className="OurTeam-titleOutside">{outsideTitle}</h2>
        </div>
      ) : null}

      <div className="OurTeam-shell">
        <div className="OurTeam-depth OurTeam-depth-1" />
        <div className="OurTeam-depth OurTeam-depth-2" />
        <div className="OurTeam-orb OurTeam-orb-1" />
        <div className="OurTeam-orb OurTeam-orb-2" />

        <div className="OurTeam-bubbles" aria-hidden="true">
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>

        <div className="OurTeam-header">
          {content.eyebrow && content.members.length > 0 ? (
            <div className="OurTeam-eyebrow">{content.eyebrow}</div>
          ) : null}

          {content.text ? (
            <p className="OurTeam-text">{content.text}</p>
          ) : null}
        </div>

        {content.members.length > 0 ? (
          <div className="OurTeam-grid">
            {content.members.map((member, index) => {
              const initials = (member?.name || "")
                .split(" ")
                .filter(Boolean)
                .slice(0, 2)
                .map((word) => word[0])
                .join("")
                .toUpperCase();

              return (
                <article
                  className="OurTeam-card"
                  key={`${member?.name || "member"}-${index}`}
                >
                  <div className="OurTeam-cardGlow" />

                  <div className="OurTeam-badge">{initials || "?"}</div>

                  {member?.name ? (
                    <h3 className="OurTeam-card-title">{member.name}</h3>
                  ) : null}

                  {member?.role ? (
                    <div className="OurTeam-card-role">{member.role}</div>
                  ) : null}

                  {member?.description ? (
                    <p className="OurTeam-card-text">{member.description}</p>
                  ) : null}
                </article>
              );
            })}
          </div>
        ) : (
          <div className="OurTeam-empty">
            <div className="OurTeam-empty-inner">
              <div className="OurTeam-radarWrap">
                <div className="OurTeam-radar">
                  <span className="OurTeam-radar-ring OurTeam-radar-ring-1" />
                  <span className="OurTeam-radar-ring OurTeam-radar-ring-2" />
                  <span className="OurTeam-radar-ring OurTeam-radar-ring-3" />
                  <span className="OurTeam-radar-sweep" />
                  <span className="OurTeam-radar-core" />
                </div>
              </div>

              <div className="OurTeam-empty-content">
                {content.noteText ? (
                  <p className="OurTeam-empty-note">{content.noteText}</p>
                ) : null}

                <div className="OurTeam-loading" aria-hidden="true">
                  <span className="OurTeam-loading-bar" />
                  <span className="OurTeam-loading-bar" />
                  <span className="OurTeam-loading-bar" />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}